import { ICrmActivity } from 'services/CrmApi/types/CrmActivityTypes';

const monthMapping = {
  '01': 'January',
  '02': 'February',
  '03': 'March',
  '04': 'April',
  '05': 'May',
  '06': 'June',
  '07': 'July',
  '08': 'August',
  '09': 'September',
  '10': 'October',
  '11': 'November',
  '12': 'December',
};

const getMonthDisplayRepresentation = (date: string): string => {
  const month = date.substring(5, 7);
  const year = date.substring(0, 4);
  return `${monthMapping[month]} ${year}`;
};

export const getUpcomingActivities = (activities: ICrmActivity[]): ICrmActivity[] => {
  const currentDate = new Date();
  return activities.filter(activity => new Date(activity.date).toISOString() >= currentDate.toISOString());
};

export const getEarlierActivities = (activities: ICrmActivity[]): ICrmActivity[] => {
  const currentDate = new Date();
  return activities.filter(activity => new Date(activity.date).toISOString() < currentDate.toISOString());
};

export const getActivitiesGroupedByMonth = (activities: ICrmActivity[]): { [key: string]: ICrmActivity[] } => {
  const groupedActivities: { [key: string]: ICrmActivity[] } = {};
  const currentDate = new Date().toISOString();

  activities.forEach(activity => {
    const activityDate = new Date(activity.date).toISOString();
    let activityMonth = getMonthDisplayRepresentation(activityDate.substring(0, 7));

    if (activityDate >= currentDate) {
      activityMonth = 'upcoming';
    }

    if (!groupedActivities[activityMonth]) {
      groupedActivities[activityMonth] = [];
    }
    groupedActivities[activityMonth].push(activity);
  });

  return groupedActivities;
};
